import React from "react";
import Grid from "@mui/material/Grid";
import { useTheme, useMediaQuery } from "@mui/material";

const ContentLayout: React.FC<{
  children: React.ReactNode;
  tableOfContents?: React.ReactNode;
}> = ({ children, tableOfContents }) => {
  const theme = useTheme();
  const isUpXl = useMediaQuery(theme.breakpoints.up("xl"));

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        xl={9}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          px: { xs: 6, md: 24 },
          pr: { xs: 6, md: 12 },
          py: { xs: 4, md: 12 },
          wordBreak: "break-word",
        }}
      >
        {children}
      </Grid>
      {tableOfContents && isUpXl && (
        <Grid
          item
          md={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {tableOfContents}
        </Grid>
      )}
    </Grid>
  );
};

export default ContentLayout;
